import { OpenAPI } from "@propertelligent/client-api";
import { UserLoginData } from "../../common/charts/Enums";

/**
 * Raw-fetch bridge to the platform-admin-only trial expiration date endpoint on OrganizationController.
 *
 * The typed client method does not exist until CI regenerates @propertelligent/client-api, so the
 * Platform Portal's org Subscription tab reaches the new PUT
 * /api/Organization/{organizationId}/trial-expiration-date endpoint through this helper. Centralizing
 * it here keeps the component presentational and gives one place to swap in the generated
 * OrganizationService method after regen (mirrors organizationEmailApi.ts / platformPaymentAccountsApi.ts).
 *
 * TODO: replace the fetch below with OrganizationService.putApiOrganizationTrialExpirationDate once
 * client-api is regenerated.
 */
export const updateTrialExpirationDate = async (
  organizationId: number,
  expirationDate: Date
): Promise<void> => {
  const token = sessionStorage.getItem(UserLoginData.token);
  const res = await fetch(
    `${OpenAPI.BASE}/api/Organization/${organizationId}/trial-expiration-date`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ expirationDate: expirationDate.toISOString() }),
    }
  );
  if (!res.ok) {
    throw res;
  }
};